import React from "react";

const ThemeContext = React.createContext({ value: {}, setValue: () => {} });

export { ThemeContext };
